import React from 'react'

const KeyboardArrowDownIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 -960 960 960" {...props} ><path d="M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z"/></svg>
  )
}

export default KeyboardArrowDownIcon